import { useCallback, useEffect, useRef } from "react"
import useResizeObserver from "web/hooks/behaviour/useResizeObserver"
import debounce from "lodash.debounce"

import { getPageOffsets } from "web/services/browser"

export default function useFullHeight({
  enabled = false,
  elementId,
  minHeightPx,
}) {
  const containerRef = useRef(null)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setFullHeight = useCallback(
    debounce(() => {
      const container = document.getElementById(elementId)
      if (!container) return

      const pageOffsets = getPageOffsets(container)

      const height = !!minHeightPx
        ? `max(calc(100vh - ${pageOffsets.top}px), ${minHeightPx}px)`
        : `calc(100vh - ${pageOffsets.top}px)`

      container.style.height = height
    }, 50),
    []
  )

  // on resize
  useEffect(() => {
    if (enabled) {
      setFullHeight()
      window.addEventListener("resize", setFullHeight)

      return () => {
        window.removeEventListener("resize", setFullHeight)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])

  useEffect(() => {
    const container = document.getElementById(elementId)
    if (!container) return

    containerRef.current = container.parentElement
  })

  useResizeObserver(containerRef, () => {
    if (enabled) {
      setFullHeight()
    }
  })
}
